import { HttpClient } from 'aurelia-fetch-client';
import { mock, instance, verify, when, anyNumber, anything, capture } from 'ts-mockito';
import { HPFServiceClient } from '../../ClientApp/services/hpfApi';
import { Router } from 'aurelia-router';
import { I18N } from 'aurelia-i18n';
import { State } from './global-state';
import { ApiResponse } from '../models/api-response';

describe('NewPortalWeb', () => {
	describe('services', () => {
		describe('HPFServiceClient', () => {
			let svc: HPFServiceClient;
			const mockHttpClient: HttpClient = mock(HttpClient);
			const mockState: State = mock();
			const mockRouter: Router = mock();
			const mockI18N: I18N = mock();

			beforeEach(() => {
				svc = new HPFServiceClient(
					instance(mockState),
					instance(mockHttpClient),
				);
			});

			describe('GET', () => {


				it('should initialize', () => {
					expect(svc).toBeTruthy();
				});

				it('should call http proper config', () => {
					let url = '/test/url/';
					let config = {
						method: 'get',
						headers: new Headers({
							'Content-Type': 'application/json'
						})
					};

					let response = {
						ok: true,
						status: 200
					};
					when(mockHttpClient.fetch(`${svc.base}${url}`, anything())).thenReturn(new Promise(() => response));
					svc.get(url);
					verify(mockHttpClient.fetch(`${svc.base}${url}`, anything())).called();
					expect(capture(mockHttpClient.fetch).last()[1]).toEqual(config);
				});
			});
		});
	});
});
